import _each from "lodash/each";
import store from "~/js/store/store";
import { gsap, Quint, Circ, Cubic } from "gsap";
import Common from "~/js/common/common";
export default class Accordion {
  constructor() {
    this.setup();
    if (location.hash) {
      this.checkHashAndOpen(location.hash);
    }
  }
  setup() {
    const trimming = document.querySelectorAll(".js-trimming");
    _each(trimming, (elm, index) => {
      let _textContent = elm.textContent.substr(0, parseInt(elm.dataset.trimming))+"…";
      let _innerHTML = elm.innerHTML;
      elm.innerHTML = '<span class="_full">'+_innerHTML+'</span><span class="_trimming">'+_textContent+'</span>';
    });

    const path = location.pathname;
    const accordions = document.querySelectorAll(".js-accordion");
    const filteredSomeClassSelector = Array.from(accordions).filter((s) => {
      const target_page = s.getAttribute('href');
      if(!target_page || target_page == "#")return true;
      return target_page.indexOf(path) != -1
    });
    _each(filteredSomeClassSelector, (elm, index) => {
      elm.addEventListener("click", (event) => {
        let target = elm.getAttribute("data-target");
        let option = elm.getAttribute("data-option");
        if (target) {
          if (option && option === "noprevent") {
            // ヘッダーが表示されてしまう問題を解決するためのdispatch
            gsap.delayedCall(0.2, () => {
              store.dispatch("scrollY", {
                y: store.state.app.scrollY + 1
              });
            });
          } else {
            event.preventDefault();
          }
          this.toggleAccordion(target, elm, option);
        }
      });
    });

    const accordionTriggers = document.querySelectorAll('.js-accordion-trigger')
    _each(accordionTriggers, (elm) => {
      elm.addEventListener('click', (event) => {
        let target = event.currentTarget
        if (target) {
          this.checkHashAndOpen(target.getAttribute("href"))
        }
      })
    })
  }

    // ハッシュ指定時に該当タグ内にアコーディオンがあった場合に開く
  checkHashAndOpen(hash) {
    let target;
    try {
      target = document.querySelector(hash);
    } catch (e) {
      return;
    }

    if (target) {
      let accordion;
      if (target.classList.contains("js-accordion") || target.classList.contains("js-accordion__inner")) {
        accordion = target;
      } else {
        accordion = target.querySelector(".js-accordion");
        if (!accordion) {
          return;
        }
      }

      let accordionTarget = accordion.getAttribute("data-target");
      if (accordionTarget) {
        this.toggleAccordion(accordionTarget, accordion, null);
        gsap.delayedCall(0.4, () => {
          gsap.to(window, {
            duration: 0.6,
            ease: Cubic.easeInOut,
            scrollTo: {
              y: target.offsetTop - 80
            }
          });
        });
      }
    }
  }

  slideDown(element) {
    // Set initial styles for the animation
    element.style.display = "block"; // Ensure the element is visible
    element.style.overflow = "hidden"; // Prevent content overflow
    element.style.height = "0"; // Start height

    // Trigger a reflow to apply the height change
    element.offsetHeight; // This forces a reflow

    // Set the target height
    element.style.height = `${element.scrollHeight}px`; // Target height

    // Use CSS transition for smooth animation
    element.style.transition = "height 0.3s ease"; // Animation duration

    // Reset the height after the transition
    setTimeout(() => {
      element.style.height = ""; // Reset to auto height
      element.style.overflow = ""; // Clear overflow
    }, 300); // Match the duration of the transition
  }

  slideUp(element) {
    // Set initial styles for the animation
    element.style.overflow = "hidden"; // Prevent overflow
    element.style.height = `${element.scrollHeight}px`; // Get the current height
    element.style.transition = "height 0.3s ease"; // Animation duration

    // Trigger a reflow to apply the height change
    element.offsetHeight; // This forces a reflow

    // Set the height to 0 to start the slide up
    element.style.height = "0"; // Start height

    // Hide the element after the transition
    setTimeout(() => {
      element.style.display = "none"; // Hide the element
      element.style.height = ""; // Clear the height
      element.style.overflow = ""; // Clear overflow
    }, 300); // Match the duration of the transition
  }

  toggleAccordion(target, button, option) {
    const targetDom = document.querySelector(target);

    if (targetDom) {
      let isAccordionOpen;
      if (option && option === "noprevent") {
        isAccordionOpen = true;
        targetDom.classList.add("accordion-open");
        this.slideDown(targetDom);
      } else {
        if (targetDom.classList.contains("accordion-open")) {
          targetDom.classList.remove("accordion-open");
          this.slideUp(targetDom);
          isAccordionOpen = false;
        } else {
          targetDom.classList.add("accordion-open");
          this.slideDown(targetDom);
          isAccordionOpen = true;
        }
      }
      if (isAccordionOpen) {
        button.classList.add("opened");
        button.setAttribute("aria-expanded", "true");
        if (option) {
          this.execOption(option, targetDom);
        }
      } else {
        button.classList.remove("opened");
        button.setAttribute("aria-expanded", "false");
      }
    }
  }

  execOption(option, target) {
    if (option === "noscroll") {
      Common.addNoscrollAllChildren(target, true);
    }
  }
}
